import { useQuery, UseQueryResult } from 'react-query';
import { queryKeys } from '../queryKeyFactory';
import { CompanyDeal } from '../../models/CompanyDeal';
import { DealsParams, fetchCompanyDeals } from '../../services/deals/deals.service';

export default (companyId: string, params: DealsParams): UseQueryResult<CompanyDeal[], Error> => {
  return useQuery<CompanyDeal[], Error>(
    queryKeys.fetchCompanyDeals.allByFilters(companyId, params),
    async () => fetchCompanyDeals(companyId, params),
    {
      enabled: !!params.enabled && !Number.isNaN(Number(companyId)),
    }
  );
};
